import axios from 'axios';
import Constants from '../config/Constants';

export default axios.create({
    baseURL: Constants.server.coingeckoURL,
    headers: {'Access-Control-Allow-Origin': '*'},
});